import { p as Pe, c as Le } from "./styled-components.browser.esm-DBaC0ZEI.mjs";
import * as a from "react";
import I, { useRef as ge, cloneElement as Ut, forwardRef as et, useState as st, useImperativeHandle as bt, useEffect as $e, useContext as Xt } from "react";
import { U as qt, q as k, p as tt, f as fe, o as we, _ as le, z as ke, i as me, v as nt, s as Ne, a as Me, D as ht, Q as ot, t as Re, O as ct, a7 as Yt, u as Gt, g as Zt, j as Jt } from "./index-CjjiqU7h.mjs";
import { A as rt } from "./AntdIcon-EfV3m8Ts.mjs";
import { R as xt } from "./index-BgcNEpwc.mjs";
import { t as Et } from "./toArray-C1Af_up9.mjs";
import { u as Te, a as St } from "./useCSSVarCls--o7XUl-F.mjs";
import { o as at } from "./omit-B_u6A-HL.mjs";
import { K as Ae } from "./motion-P3tHGbiP.mjs";
import { u as Qt } from "./useLocale-BP_KijF7.mjs";
import { T as it } from "./index-BP092b3A.mjs";
import { c as en } from "./reactNode-CwSzDQK_.mjs";
import { C as tn } from "./CloseCircleFilled-MnFa8sCv.mjs";
import { u as Ct, b as wt, c as Je, g as Ot, C as nn } from "./index-DIiEiQf8.mjs";
import { a as on, u as Rt } from "./Compact-8zmhZt2C.mjs";
import { F as Nt } from "./context-CqAjIyj3.mjs";
import { C as ut } from "./ContextIsolator-DZCr818D.mjs";
import { g as rn } from "./_commonjsHelpers-B7iq2c9Y.mjs";
import { L as an } from "./LoadingOutlined-CwpxM4LT.mjs";
const $t = (e) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${e.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
});
var Tt = function(n) {
  if (qt() && window.document.documentElement) {
    var o = Array.isArray(n) ? n : [n], t = window.document.documentElement;
    return o.some(function(r) {
      return r in t.style;
    });
  }
  return !1;
}, ln = function(n, o) {
  if (!Tt(n))
    return !1;
  var t = document.createElement("div"), r = t.style[n];
  return t.style[n] = o, t.style[n] !== r;
};
function dt(e, n) {
  return !Array.isArray(e) && n !== void 0 ? ln(e, n) : Tt(e);
}
function sn(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function cn(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function ft(e, n, o) {
  var t = n.cloneNode(!0), r = Object.create(e, {
    target: {
      value: t
    },
    currentTarget: {
      value: t
    }
  });
  return t.value = o, typeof n.selectionStart == "number" && typeof n.selectionEnd == "number" && (t.selectionStart = n.selectionStart, t.selectionEnd = n.selectionEnd), t.setSelectionRange = function() {
    n.setSelectionRange.apply(n, arguments);
  }, r;
}
function De(e, n, o, t) {
  if (o) {
    var r = n;
    if (n.type === "click") {
      r = ft(n, e, ""), o(r);
      return;
    }
    if (e.type !== "file" && t !== void 0) {
      r = ft(n, e, t), o(r);
      return;
    }
    o(r);
  }
}
function un(e, n) {
  if (e) {
    e.focus(n);
    var o = n || {}, t = o.cursor;
    if (t) {
      var r = e.value.length;
      switch (t) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(r, r);
          break;
        default:
          e.setSelectionRange(0, r);
      }
    }
  }
}
var It = /* @__PURE__ */ I.forwardRef(function(e, n) {
  var o, t, r = e.inputElement, l = e.children, s = e.prefixCls, c = e.prefix, g = e.suffix, u = e.addonBefore, i = e.addonAfter, v = e.className, m = e.style, E = e.disabled, S = e.readOnly, z = e.focused, H = e.triggerFocus, M = e.allowClear, V = e.value, f = e.handleReset, D = e.hidden, y = e.classes, p = e.classNames, F = e.dataAttrs, h = e.styles, d = e.components, G = l ?? r, q = (d == null ? void 0 : d.affixWrapper) || "span", C = (d == null ? void 0 : d.groupWrapper) || "span", j = (d == null ? void 0 : d.wrapper) || "span", x = (d == null ? void 0 : d.groupAddon) || "span", R = ge(null), N = function(K) {
    var Ee;
    (Ee = R.current) !== null && Ee !== void 0 && Ee.contains(K.target) && (H == null || H());
  }, B = cn(e), w = /* @__PURE__ */ Ut(G, {
    value: V,
    className: k(G.props.className, !B && (p == null ? void 0 : p.variant)) || null
  }), W = ge(null);
  if (I.useImperativeHandle(n, function() {
    return {
      nativeElement: W.current || R.current
    };
  }), B) {
    var P, U = null;
    if (M) {
      var te, Z = !E && !S && V, Y = "".concat(s, "-clear-icon"), X = tt(M) === "object" && M !== null && M !== void 0 && M.clearIcon ? M.clearIcon : "✖";
      U = /* @__PURE__ */ I.createElement("span", {
        onClick: f,
        onMouseDown: function(K) {
          return K.preventDefault();
        },
        className: k(Y, (te = {}, fe(te, "".concat(Y, "-hidden"), !Z), fe(te, "".concat(Y, "-has-suffix"), !!g), te)),
        role: "button",
        tabIndex: -1
      }, X);
    }
    var $ = "".concat(s, "-affix-wrapper"), ae = k($, (P = {}, fe(P, "".concat(s, "-disabled"), E), fe(P, "".concat($, "-disabled"), E), fe(P, "".concat($, "-focused"), z), fe(P, "".concat($, "-readonly"), S), fe(P, "".concat($, "-input-with-clear-btn"), g && M && V), P), y == null ? void 0 : y.affixWrapper, p == null ? void 0 : p.affixWrapper, p == null ? void 0 : p.variant), ce = (g || M) && /* @__PURE__ */ I.createElement("span", {
      className: k("".concat(s, "-suffix"), p == null ? void 0 : p.suffix),
      style: h == null ? void 0 : h.suffix
    }, U, g);
    w = /* @__PURE__ */ I.createElement(q, we({
      className: ae,
      style: h == null ? void 0 : h.affixWrapper,
      onClick: N
    }, F == null ? void 0 : F.affixWrapper, {
      ref: R
    }), c && /* @__PURE__ */ I.createElement("span", {
      className: k("".concat(s, "-prefix"), p == null ? void 0 : p.prefix),
      style: h == null ? void 0 : h.prefix
    }, c), w, ce);
  }
  if (sn(e)) {
    var se = "".concat(s, "-group"), ue = "".concat(se, "-addon"), ye = "".concat(se, "-wrapper"), ne = k("".concat(s, "-wrapper"), se, y == null ? void 0 : y.wrapper, p == null ? void 0 : p.wrapper), Q = k(ye, fe({}, "".concat(ye, "-disabled"), E), y == null ? void 0 : y.group, p == null ? void 0 : p.groupWrapper);
    w = /* @__PURE__ */ I.createElement(C, {
      className: Q,
      ref: W
    }, /* @__PURE__ */ I.createElement(j, {
      className: ne
    }, u && /* @__PURE__ */ I.createElement(x, {
      className: ue
    }, u), w, i && /* @__PURE__ */ I.createElement(x, {
      className: ue
    }, i)));
  }
  return /* @__PURE__ */ I.cloneElement(w, {
    className: k((o = w.props) === null || o === void 0 ? void 0 : o.className, v) || null,
    style: le(le({}, (t = w.props) === null || t === void 0 ? void 0 : t.style), m),
    hidden: D
  });
}), dn = ["show"];
function _t(e, n) {
  return a.useMemo(function() {
    var o = {};
    n && (o.show = tt(n) === "object" && n.formatter ? n.formatter : !!n), o = le(le({}, o), e);
    var t = o, r = t.show, l = ke(t, dn);
    return le(le({}, l), {}, {
      show: !!r,
      showFormatter: typeof r == "function" ? r : void 0,
      strategy: l.strategy || function(s) {
        return s.length;
      }
    });
  }, [e, n]);
}
var fn = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], pn = /* @__PURE__ */ et(function(e, n) {
  var o = e.autoComplete, t = e.onChange, r = e.onFocus, l = e.onBlur, s = e.onPressEnter, c = e.onKeyDown, g = e.prefixCls, u = g === void 0 ? "rc-input" : g, i = e.disabled, v = e.htmlSize, m = e.className, E = e.maxLength, S = e.suffix, z = e.showCount, H = e.count, M = e.type, V = M === void 0 ? "text" : M, f = e.classes, D = e.classNames, y = e.styles, p = e.onCompositionStart, F = e.onCompositionEnd, h = ke(e, fn), d = st(!1), G = me(d, 2), q = G[0], C = G[1], j = ge(!1), x = ge(null), R = ge(null), N = function(A) {
    x.current && un(x.current, A);
  }, B = Te(e.defaultValue, {
    value: e.value
  }), w = me(B, 2), W = w[0], P = w[1], U = W == null ? "" : String(W), te = st(null), Z = me(te, 2), Y = Z[0], X = Z[1], $ = _t(H, z), ae = $.max || E, ce = $.strategy(U), se = !!ae && ce > ae;
  bt(n, function() {
    var _;
    return {
      focus: N,
      blur: function() {
        var J;
        (J = x.current) === null || J === void 0 || J.blur();
      },
      setSelectionRange: function(J, be, he) {
        var ie;
        (ie = x.current) === null || ie === void 0 || ie.setSelectionRange(J, be, he);
      },
      select: function() {
        var J;
        (J = x.current) === null || J === void 0 || J.select();
      },
      input: x.current,
      nativeElement: ((_ = R.current) === null || _ === void 0 ? void 0 : _.nativeElement) || x.current
    };
  }), $e(function() {
    C(function(_) {
      return _ && i ? !1 : _;
    });
  }, [i]);
  var ue = function(A, J, be) {
    var he = J;
    if (!j.current && $.exceedFormatter && $.max && $.strategy(J) > $.max) {
      if (he = $.exceedFormatter(J, {
        max: $.max
      }), J !== he) {
        var ie, ve;
        X([((ie = x.current) === null || ie === void 0 ? void 0 : ie.selectionStart) || 0, ((ve = x.current) === null || ve === void 0 ? void 0 : ve.selectionEnd) || 0]);
      }
    } else if (be.source === "compositionEnd")
      return;
    P(he), x.current && De(x.current, A, t, he);
  };
  $e(function() {
    if (Y) {
      var _;
      (_ = x.current) === null || _ === void 0 || _.setSelectionRange.apply(_, nt(Y));
    }
  }, [Y]);
  var ye = function(A) {
    ue(A, A.target.value, {
      source: "change"
    });
  }, ne = function(A) {
    j.current = !1, ue(A, A.currentTarget.value, {
      source: "compositionEnd"
    }), F == null || F(A);
  }, Q = function(A) {
    s && A.key === "Enter" && s(A), c == null || c(A);
  }, O = function(A) {
    C(!0), r == null || r(A);
  }, K = function(A) {
    C(!1), l == null || l(A);
  }, Ee = function(A) {
    P(""), N(), x.current && De(x.current, A, t);
  }, re = se && "".concat(u, "-out-of-range"), Se = function() {
    var A = at(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ I.createElement("input", we({
      autoComplete: o
    }, A, {
      onChange: ye,
      onFocus: O,
      onBlur: K,
      onKeyDown: Q,
      className: k(u, fe({}, "".concat(u, "-disabled"), i), D == null ? void 0 : D.input),
      style: y == null ? void 0 : y.input,
      ref: x,
      size: v,
      type: V,
      onCompositionStart: function(be) {
        j.current = !0, p == null || p(be);
      },
      onCompositionEnd: ne
    }));
  }, Ce = function() {
    var A = Number(ae) > 0;
    if (S || $.show) {
      var J = $.showFormatter ? $.showFormatter({
        value: U,
        count: ce,
        maxLength: ae
      }) : "".concat(ce).concat(A ? " / ".concat(ae) : "");
      return /* @__PURE__ */ I.createElement(I.Fragment, null, $.show && /* @__PURE__ */ I.createElement("span", {
        className: k("".concat(u, "-show-count-suffix"), fe({}, "".concat(u, "-show-count-has-suffix"), !!S), D == null ? void 0 : D.count),
        style: le({}, y == null ? void 0 : y.count)
      }, J), S);
    }
    return null;
  };
  return /* @__PURE__ */ I.createElement(It, we({}, h, {
    prefixCls: u,
    className: k(m, re),
    handleReset: Ee,
    value: U,
    focused: q,
    triggerFocus: N,
    suffix: Ce(),
    disabled: i,
    classes: f,
    classNames: D,
    styles: y
  }), Se());
});
const vn = (e) => {
  let n;
  return typeof e == "object" && (e != null && e.clearIcon) ? n = e : e && (n = {
    clearIcon: /* @__PURE__ */ I.createElement(tn, null)
  }), n;
}, zt = vn;
function mn(e, n) {
  const o = ge([]), t = () => {
    o.current.push(setTimeout(() => {
      var r, l, s, c;
      !((r = e.current) === null || r === void 0) && r.input && ((l = e.current) === null || l === void 0 ? void 0 : l.input.getAttribute("type")) === "password" && (!((s = e.current) === null || s === void 0) && s.input.hasAttribute("value")) && ((c = e.current) === null || c === void 0 || c.input.removeAttribute("value"));
    }));
  };
  return $e(() => (n && t(), () => o.current.forEach((r) => {
    r && clearTimeout(r);
  })), []), t;
}
function gn(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var yn = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
function bn(e, n) {
  if (!e)
    return;
  e.focus(n);
  const {
    cursor: o
  } = n || {};
  if (o) {
    const t = e.value.length;
    switch (o) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(t, t);
        break;
      default:
        e.setSelectionRange(0, t);
    }
  }
}
const jt = /* @__PURE__ */ et((e, n) => {
  var o;
  const {
    prefixCls: t,
    bordered: r = !0,
    status: l,
    size: s,
    disabled: c,
    onBlur: g,
    onFocus: u,
    suffix: i,
    allowClear: v,
    addonAfter: m,
    addonBefore: E,
    className: S,
    style: z,
    styles: H,
    rootClassName: M,
    onChange: V,
    classNames: f,
    variant: D
  } = e, y = yn(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: O
    } = Ne("Input");
    O(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: p,
    direction: F,
    input: h
  } = I.useContext(Me), d = p("input", t), G = ge(null), q = St(d), [C, j, x] = Ct(d, q), {
    compactSize: R,
    compactItemClassnames: N
  } = on(d, F), B = Rt((O) => {
    var K;
    return (K = s ?? R) !== null && K !== void 0 ? K : O;
  }), w = I.useContext(ht), W = c ?? w, {
    status: P,
    hasFeedback: U,
    feedbackIcon: te
  } = Xt(Nt), Z = Ot(P, l), Y = gn(e) || !!U, X = ge(Y);
  if (process.env.NODE_ENV !== "production") {
    const O = Ne("Input");
    $e(() => {
      var K;
      Y && !X.current && process.env.NODE_ENV !== "production" && O(document.activeElement === ((K = G.current) === null || K === void 0 ? void 0 : K.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), X.current = Y;
    }, [Y]);
  }
  const $ = mn(G, !0), ae = (O) => {
    $(), g == null || g(O);
  }, ce = (O) => {
    $(), u == null || u(O);
  }, se = (O) => {
    $(), V == null || V(O);
  }, ue = (U || i) && /* @__PURE__ */ I.createElement(I.Fragment, null, i, U && te), ye = zt(v ?? (h == null ? void 0 : h.allowClear)), [ne, Q] = wt("input", D, r);
  return C(/* @__PURE__ */ I.createElement(pn, Object.assign({
    ref: ot(n, G),
    prefixCls: d,
    autoComplete: h == null ? void 0 : h.autoComplete
  }, y, {
    disabled: W,
    onBlur: ae,
    onFocus: ce,
    style: Object.assign(Object.assign({}, h == null ? void 0 : h.style), z),
    styles: Object.assign(Object.assign({}, h == null ? void 0 : h.styles), H),
    suffix: ue,
    allowClear: ye,
    className: k(S, M, x, q, N, h == null ? void 0 : h.className),
    onChange: se,
    addonBefore: E && /* @__PURE__ */ I.createElement(ut, {
      form: !0,
      space: !0
    }, E),
    addonAfter: m && /* @__PURE__ */ I.createElement(ut, {
      form: !0,
      space: !0
    }, m),
    classNames: Object.assign(Object.assign(Object.assign({}, f), h == null ? void 0 : h.classNames), {
      input: k({
        [`${d}-sm`]: B === "small",
        [`${d}-lg`]: B === "large",
        [`${d}-rtl`]: F === "rtl"
      }, f == null ? void 0 : f.input, (o = h == null ? void 0 : h.classNames) === null || o === void 0 ? void 0 : o.input, j),
      variant: k({
        [`${d}-${ne}`]: Q
      }, Je(d, Z)),
      affixWrapper: k({
        [`${d}-affix-wrapper-sm`]: B === "small",
        [`${d}-affix-wrapper-lg`]: B === "large",
        [`${d}-affix-wrapper-rtl`]: F === "rtl"
      }, j),
      wrapper: k({
        [`${d}-group-rtl`]: F === "rtl"
      }, j),
      groupWrapper: k({
        [`${d}-group-wrapper-sm`]: B === "small",
        [`${d}-group-wrapper-lg`]: B === "large",
        [`${d}-group-wrapper-rtl`]: F === "rtl",
        [`${d}-group-wrapper-${ne}`]: Q
      }, Je(`${d}-group-wrapper`, Z, U), j)
    })
  })));
});
process.env.NODE_ENV !== "production" && (jt.displayName = "Input");
const er = jt;
var hn = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, xn = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], He = {}, pe;
function En(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (n && He[o])
    return He[o];
  var t = window.getComputedStyle(e), r = t.getPropertyValue("box-sizing") || t.getPropertyValue("-moz-box-sizing") || t.getPropertyValue("-webkit-box-sizing"), l = parseFloat(t.getPropertyValue("padding-bottom")) + parseFloat(t.getPropertyValue("padding-top")), s = parseFloat(t.getPropertyValue("border-bottom-width")) + parseFloat(t.getPropertyValue("border-top-width")), c = xn.map(function(u) {
    return "".concat(u, ":").concat(t.getPropertyValue(u));
  }).join(";"), g = {
    sizingStyle: c,
    paddingSize: l,
    borderSize: s,
    boxSizing: r
  };
  return n && o && (He[o] = g), g;
}
function Sn(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  pe || (pe = document.createElement("textarea"), pe.setAttribute("tab-index", "-1"), pe.setAttribute("aria-hidden", "true"), document.body.appendChild(pe)), e.getAttribute("wrap") ? pe.setAttribute("wrap", e.getAttribute("wrap")) : pe.removeAttribute("wrap");
  var r = En(e, n), l = r.paddingSize, s = r.borderSize, c = r.boxSizing, g = r.sizingStyle;
  pe.setAttribute("style", "".concat(g, ";").concat(hn)), pe.value = e.value || e.placeholder || "";
  var u = void 0, i = void 0, v, m = pe.scrollHeight;
  if (c === "border-box" ? m += s : c === "content-box" && (m -= l), o !== null || t !== null) {
    pe.value = " ";
    var E = pe.scrollHeight - l;
    o !== null && (u = E * o, c === "border-box" && (u = u + l + s), m = Math.max(u, m)), t !== null && (i = E * t, c === "border-box" && (i = i + l + s), v = m > i ? "" : "hidden", m = Math.min(i, m));
  }
  var S = {
    height: m,
    overflowY: v,
    resize: "none"
  };
  return u && (S.minHeight = u), i && (S.maxHeight = i), S;
}
var Cn = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], We = 0, Ke = 1, Ue = 2, wn = /* @__PURE__ */ a.forwardRef(function(e, n) {
  var o = e, t = o.prefixCls;
  o.onPressEnter;
  var r = o.defaultValue, l = o.value, s = o.autoSize, c = o.onResize, g = o.className, u = o.style, i = o.disabled, v = o.onChange, m = o.onInternalAutoSize, E = ke(o, Cn), S = Te(r, {
    value: l,
    postState: function(X) {
      return X ?? "";
    }
  }), z = me(S, 2), H = z[0], M = z[1], V = function(X) {
    M(X.target.value), v == null || v(X);
  }, f = a.useRef();
  a.useImperativeHandle(n, function() {
    return {
      textArea: f.current
    };
  });
  var D = a.useMemo(function() {
    return s && tt(s) === "object" ? [s.minRows, s.maxRows] : [];
  }, [s]), y = me(D, 2), p = y[0], F = y[1], h = !!s, d = function() {
    try {
      if (document.activeElement === f.current) {
        var X = f.current, $ = X.selectionStart, ae = X.selectionEnd, ce = X.scrollTop;
        f.current.setSelectionRange($, ae), f.current.scrollTop = ce;
      }
    } catch {
    }
  }, G = a.useState(Ue), q = me(G, 2), C = q[0], j = q[1], x = a.useState(), R = me(x, 2), N = R[0], B = R[1], w = function() {
    j(We), process.env.NODE_ENV === "test" && (m == null || m());
  };
  Re(function() {
    h && w();
  }, [l, p, F, h]), Re(function() {
    if (C === We)
      j(Ke);
    else if (C === Ke) {
      var Y = Sn(f.current, !1, p, F);
      j(Ue), B(Y);
    } else
      d();
  }, [C]);
  var W = a.useRef(), P = function() {
    ct.cancel(W.current);
  }, U = function(X) {
    C === Ue && (c == null || c(X), s && (P(), W.current = ct(function() {
      w();
    })));
  };
  a.useEffect(function() {
    return P;
  }, []);
  var te = h ? N : null, Z = le(le({}, u), te);
  return (C === We || C === Ke) && (Z.overflowY = "hidden", Z.overflowX = "hidden"), /* @__PURE__ */ a.createElement(xt, {
    onResize: U,
    disabled: !(s || c)
  }, /* @__PURE__ */ a.createElement("textarea", we({}, E, {
    ref: f,
    style: Z,
    className: k(t, g, fe({}, "".concat(t, "-disabled"), i)),
    disabled: i,
    value: H,
    onChange: V
  })));
}), On = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "readOnly"], Rn = /* @__PURE__ */ I.forwardRef(function(e, n) {
  var o, t = e.defaultValue, r = e.value, l = e.onFocus, s = e.onBlur, c = e.onChange, g = e.allowClear, u = e.maxLength, i = e.onCompositionStart, v = e.onCompositionEnd, m = e.suffix, E = e.prefixCls, S = E === void 0 ? "rc-textarea" : E, z = e.showCount, H = e.count, M = e.className, V = e.style, f = e.disabled, D = e.hidden, y = e.classNames, p = e.styles, F = e.onResize, h = e.readOnly, d = ke(e, On), G = Te(t, {
    value: r,
    defaultValue: t
  }), q = me(G, 2), C = q[0], j = q[1], x = C == null ? "" : String(C), R = I.useState(!1), N = me(R, 2), B = N[0], w = N[1], W = I.useRef(!1), P = I.useState(null), U = me(P, 2), te = U[0], Z = U[1], Y = ge(null), X = ge(null), $ = function() {
    var L;
    return (L = X.current) === null || L === void 0 ? void 0 : L.textArea;
  }, ae = function() {
    $().focus();
  };
  bt(n, function() {
    var ee;
    return {
      resizableTextArea: X.current,
      focus: ae,
      blur: function() {
        $().blur();
      },
      nativeElement: ((ee = Y.current) === null || ee === void 0 ? void 0 : ee.nativeElement) || $()
    };
  }), $e(function() {
    w(function(ee) {
      return !f && ee;
    });
  }, [f]);
  var ce = I.useState(null), se = me(ce, 2), ue = se[0], ye = se[1];
  I.useEffect(function() {
    if (ue) {
      var ee;
      (ee = $()).setSelectionRange.apply(ee, nt(ue));
    }
  }, [ue]);
  var ne = _t(H, z), Q = (o = ne.max) !== null && o !== void 0 ? o : u, O = Number(Q) > 0, K = ne.strategy(x), Ee = !!Q && K > Q, re = function(L, oe) {
    var de = oe;
    !W.current && ne.exceedFormatter && ne.max && ne.strategy(oe) > ne.max && (de = ne.exceedFormatter(oe, {
      max: ne.max
    }), oe !== de && ye([$().selectionStart || 0, $().selectionEnd || 0])), j(de), De(L.currentTarget, L, c, de);
  }, Se = function(L) {
    W.current = !0, i == null || i(L);
  }, Ce = function(L) {
    W.current = !1, re(L, L.currentTarget.value), v == null || v(L);
  }, _ = function(L) {
    re(L, L.target.value);
  }, A = function(L) {
    var oe = d.onPressEnter, de = d.onKeyDown;
    L.key === "Enter" && oe && oe(L), de == null || de(L);
  }, J = function(L) {
    w(!0), l == null || l(L);
  }, be = function(L) {
    w(!1), s == null || s(L);
  }, he = function(L) {
    j(""), ae(), De($(), L, c);
  }, ie = m, ve;
  ne.show && (ne.showFormatter ? ve = ne.showFormatter({
    value: x,
    count: K,
    maxLength: Q
  }) : ve = "".concat(K).concat(O ? " / ".concat(Q) : ""), ie = /* @__PURE__ */ I.createElement(I.Fragment, null, ie, /* @__PURE__ */ I.createElement("span", {
    className: k("".concat(S, "-data-count"), y == null ? void 0 : y.count),
    style: p == null ? void 0 : p.count
  }, ve)));
  var Ie = function(L) {
    var oe;
    F == null || F(L), (oe = $()) !== null && oe !== void 0 && oe.style.height && Z(!0);
  }, Fe = !d.autoSize && !z && !g;
  return /* @__PURE__ */ I.createElement(It, {
    ref: Y,
    value: x,
    allowClear: g,
    handleReset: he,
    suffix: ie,
    prefixCls: S,
    classNames: le(le({}, y), {}, {
      affixWrapper: k(y == null ? void 0 : y.affixWrapper, fe(fe({}, "".concat(S, "-show-count"), z), "".concat(S, "-textarea-allow-clear"), g))
    }),
    disabled: f,
    focused: B,
    className: k(M, Ee && "".concat(S, "-out-of-range")),
    style: le(le({}, V), te && !Fe ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof ve == "string" ? ve : void 0
      }
    },
    hidden: D,
    readOnly: h
  }, /* @__PURE__ */ I.createElement(wn, we({}, d, {
    maxLength: u,
    onKeyDown: A,
    onChange: _,
    onFocus: J,
    onBlur: be,
    onCompositionStart: Se,
    onCompositionEnd: Ce,
    className: k(y == null ? void 0 : y.textarea),
    style: le(le({}, p == null ? void 0 : p.textarea), {}, {
      resize: V == null ? void 0 : V.resize
    }),
    disabled: f,
    prefixCls: S,
    onResize: Ie,
    ref: X,
    readOnly: h
  })));
}), Nn = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
const $n = /* @__PURE__ */ et((e, n) => {
  var o, t;
  const {
    prefixCls: r,
    bordered: l = !0,
    size: s,
    disabled: c,
    status: g,
    allowClear: u,
    classNames: i,
    rootClassName: v,
    className: m,
    style: E,
    styles: S,
    variant: z
  } = e, H = Nn(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: P
    } = Ne("TextArea");
    P(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: M,
    direction: V,
    textArea: f
  } = a.useContext(Me), D = Rt(s), y = a.useContext(ht), p = c ?? y, {
    status: F,
    hasFeedback: h,
    feedbackIcon: d
  } = a.useContext(Nt), G = Ot(F, g), q = a.useRef(null);
  a.useImperativeHandle(n, () => {
    var P;
    return {
      resizableTextArea: (P = q.current) === null || P === void 0 ? void 0 : P.resizableTextArea,
      focus: (U) => {
        var te, Z;
        bn((Z = (te = q.current) === null || te === void 0 ? void 0 : te.resizableTextArea) === null || Z === void 0 ? void 0 : Z.textArea, U);
      },
      blur: () => {
        var U;
        return (U = q.current) === null || U === void 0 ? void 0 : U.blur();
      }
    };
  });
  const C = M("input", r), j = St(C), [x, R, N] = Ct(C, j), [B, w] = wt("textArea", z, l), W = zt(u ?? (f == null ? void 0 : f.allowClear));
  return x(/* @__PURE__ */ a.createElement(Rn, Object.assign({
    autoComplete: f == null ? void 0 : f.autoComplete
  }, H, {
    style: Object.assign(Object.assign({}, f == null ? void 0 : f.style), E),
    styles: Object.assign(Object.assign({}, f == null ? void 0 : f.styles), S),
    disabled: p,
    allowClear: W,
    className: k(N, j, m, v, f == null ? void 0 : f.className),
    classNames: Object.assign(Object.assign(Object.assign({}, i), f == null ? void 0 : f.classNames), {
      textarea: k({
        [`${C}-sm`]: D === "small",
        [`${C}-lg`]: D === "large"
      }, R, i == null ? void 0 : i.textarea, (o = f == null ? void 0 : f.classNames) === null || o === void 0 ? void 0 : o.textarea),
      variant: k({
        [`${C}-${B}`]: w
      }, Je(C, G)),
      affixWrapper: k(`${C}-textarea-affix-wrapper`, {
        [`${C}-affix-wrapper-rtl`]: V === "rtl",
        [`${C}-affix-wrapper-sm`]: D === "small",
        [`${C}-affix-wrapper-lg`]: D === "large",
        [`${C}-textarea-show-count`]: e.showCount || ((t = e.count) === null || t === void 0 ? void 0 : t.show)
      }, R)
    }),
    prefixCls: C,
    suffix: h && /* @__PURE__ */ a.createElement("span", {
      className: `${C}-textarea-suffix`
    }, d),
    ref: q
  })));
}), Tn = $n;
var In = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
const _n = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-flex"
}, zn = /* @__PURE__ */ a.forwardRef((e, n) => {
  const o = (i) => {
    const {
      keyCode: v
    } = i;
    v === Ae.ENTER && i.preventDefault();
  }, t = (i) => {
    const {
      keyCode: v
    } = i, {
      onClick: m
    } = e;
    v === Ae.ENTER && m && m();
  }, {
    style: r,
    noStyle: l,
    disabled: s,
    tabIndex: c = 0
  } = e, g = In(e, ["style", "noStyle", "disabled", "tabIndex"]);
  let u = {};
  return l || (u = Object.assign({}, _n)), s && (u.pointerEvents = "none"), u = Object.assign(Object.assign({}, u), r), /* @__PURE__ */ a.createElement("div", Object.assign({
    role: "button",
    tabIndex: c,
    ref: n
  }, g, {
    onKeyDown: o,
    onKeyUp: t,
    style: u
  }));
}), Qe = zn;
var jn = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
const An = jn;
var Dn = function(n, o) {
  return /* @__PURE__ */ a.createElement(rt, we({}, n, {
    ref: o,
    icon: An
  }));
}, At = /* @__PURE__ */ a.forwardRef(Dn);
process.env.NODE_ENV !== "production" && (At.displayName = "EditOutlined");
const Pn = At;
var Ln = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
const kn = Ln;
var Mn = function(n, o) {
  return /* @__PURE__ */ a.createElement(rt, we({}, n, {
    ref: o,
    icon: kn
  }));
}, Dt = /* @__PURE__ */ a.forwardRef(Mn);
process.env.NODE_ENV !== "production" && (Dt.displayName = "EnterOutlined");
const Vn = Dt, Fn = (e, n, o, t) => {
  const {
    titleMarginBottom: r,
    fontWeightStrong: l
  } = t;
  return {
    marginBottom: r,
    color: o,
    fontWeight: l,
    fontSize: e,
    lineHeight: n
  };
}, Bn = (e) => {
  const n = [1, 2, 3, 4, 5], o = {};
  return n.forEach((t) => {
    o[`
      h${t}&,
      div&-h${t},
      div&-h${t} > textarea,
      h${t}
    `] = Fn(e[`fontSizeHeading${t}`], e[`lineHeightHeading${t}`], e.colorTextHeading, e);
  }), o;
}, Hn = (e) => {
  const {
    componentCls: n
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, $t(e)), {
      textDecoration: e.linkDecoration,
      "&:active, &:hover": {
        textDecoration: e.linkHoverDecoration
      },
      [`&[disabled], &${n}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, Wn = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: Yt[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), Kn = (e) => {
  const {
    componentCls: n,
    paddingSM: o
  } = e, t = o;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(t).mul(-1).equal(),
        marginBottom: `calc(1em - ${Gt(t)})`
      },
      [`${n}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, Un = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), Xn = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-ellipsis-single-line": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), qn = (e) => {
  const {
    componentCls: n,
    titleMarginTop: o
  } = e;
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${n}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${n}-success`]: {
        color: e.colorSuccess
      },
      [`&${n}-warning`]: {
        color: e.colorWarning
      },
      [`&${n}-danger`]: {
        color: e.colorError,
        "a&:active, a&:focus": {
          color: e.colorErrorActive
        },
        "a&:hover": {
          color: e.colorErrorHover
        }
      },
      [`&${n}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, Bn(e)), {
      [`
      & + h1${n},
      & + h2${n},
      & + h3${n},
      & + h4${n},
      & + h5${n}
      `]: {
        marginTop: o
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: o
        }
      }
    }), Wn(e)), Hn(e)), {
      // Operation
      [`
        ${n}-expand,
        ${n}-collapse,
        ${n}-edit,
        ${n}-copy
      `]: Object.assign(Object.assign({}, $t(e)), {
        marginInlineStart: e.marginXXS
      })
    }), Kn(e)), Un(e)), Xn()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, Yn = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), Pt = Zt("Typography", (e) => [qn(e)], Yn), Gn = (e) => {
  const {
    prefixCls: n,
    "aria-label": o,
    className: t,
    style: r,
    direction: l,
    maxLength: s,
    autoSize: c = !0,
    value: g,
    onSave: u,
    onCancel: i,
    onEnd: v,
    component: m,
    enterIcon: E = /* @__PURE__ */ a.createElement(Vn, null)
  } = e, S = a.useRef(null), z = a.useRef(!1), H = a.useRef(), [M, V] = a.useState(g);
  a.useEffect(() => {
    V(g);
  }, [g]), a.useEffect(() => {
    var R;
    if (!((R = S.current) === null || R === void 0) && R.resizableTextArea) {
      const {
        textArea: N
      } = S.current.resizableTextArea;
      N.focus();
      const {
        length: B
      } = N.value;
      N.setSelectionRange(B, B);
    }
  }, []);
  const f = (R) => {
    let {
      target: N
    } = R;
    V(N.value.replace(/[\n\r]/g, ""));
  }, D = () => {
    z.current = !0;
  }, y = () => {
    z.current = !1;
  }, p = (R) => {
    let {
      keyCode: N
    } = R;
    z.current || (H.current = N);
  }, F = () => {
    u(M.trim());
  }, h = (R) => {
    let {
      keyCode: N,
      ctrlKey: B,
      altKey: w,
      metaKey: W,
      shiftKey: P
    } = R;
    H.current === N && !z.current && !B && !w && !W && !P && (N === Ae.ENTER ? (F(), v == null || v()) : N === Ae.ESC && i());
  }, d = () => {
    F();
  }, G = m ? `${n}-${m}` : "", [q, C, j] = Pt(n), x = k(n, `${n}-edit-content`, {
    [`${n}-rtl`]: l === "rtl"
  }, t, G, C, j);
  return q(/* @__PURE__ */ a.createElement("div", {
    className: x,
    style: r
  }, /* @__PURE__ */ a.createElement(Tn, {
    ref: S,
    maxLength: s,
    value: M,
    onChange: f,
    onKeyDown: p,
    onKeyUp: h,
    onCompositionStart: D,
    onCompositionEnd: y,
    onBlur: d,
    "aria-label": o,
    rows: 1,
    autoSize: c
  }), E !== null ? en(E, {
    className: `${n}-edit-content-confirm`
  }) : null));
}, Zn = Gn;
var Jn = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var n = document.activeElement, o = [], t = 0; t < e.rangeCount; t++)
    o.push(e.getRangeAt(t));
  switch (n.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      n.blur();
      break;
    default:
      n = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || o.forEach(function(r) {
      e.addRange(r);
    }), n && n.focus();
  };
}, Qn = Jn, pt = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, eo = "Copy to clipboard: #{key}, Enter";
function to(e) {
  var n = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, n);
}
function no(e, n) {
  var o, t, r, l, s, c, g = !1;
  n || (n = {}), o = n.debug || !1;
  try {
    r = Qn(), l = document.createRange(), s = document.getSelection(), c = document.createElement("span"), c.textContent = e, c.ariaHidden = "true", c.style.all = "unset", c.style.position = "fixed", c.style.top = 0, c.style.clip = "rect(0, 0, 0, 0)", c.style.whiteSpace = "pre", c.style.webkitUserSelect = "text", c.style.MozUserSelect = "text", c.style.msUserSelect = "text", c.style.userSelect = "text", c.addEventListener("copy", function(i) {
      if (i.stopPropagation(), n.format)
        if (i.preventDefault(), typeof i.clipboardData > "u") {
          o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var v = pt[n.format] || pt.default;
          window.clipboardData.setData(v, e);
        } else
          i.clipboardData.clearData(), i.clipboardData.setData(n.format, e);
      n.onCopy && (i.preventDefault(), n.onCopy(i.clipboardData));
    }), document.body.appendChild(c), l.selectNodeContents(c), s.addRange(l);
    var u = document.execCommand("copy");
    if (!u)
      throw new Error("copy command was unsuccessful");
    g = !0;
  } catch (i) {
    o && console.error("unable to copy using execCommand: ", i), o && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(n.format || "text", e), n.onCopy && n.onCopy(window.clipboardData), g = !0;
    } catch (v) {
      o && console.error("unable to copy using clipboardData: ", v), o && console.error("falling back to prompt"), t = to("message" in n ? n.message : eo), window.prompt(t, e);
    }
  } finally {
    s && (typeof s.removeRange == "function" ? s.removeRange(l) : s.removeAllRanges()), c && document.body.removeChild(c), r();
  }
  return g;
}
var oo = no;
const ro = /* @__PURE__ */ rn(oo);
var ao = function(e, n, o, t) {
  function r(l) {
    return l instanceof o ? l : new o(function(s) {
      s(l);
    });
  }
  return new (o || (o = Promise))(function(l, s) {
    function c(i) {
      try {
        u(t.next(i));
      } catch (v) {
        s(v);
      }
    }
    function g(i) {
      try {
        u(t.throw(i));
      } catch (v) {
        s(v);
      }
    }
    function u(i) {
      i.done ? l(i.value) : r(i.value).then(c, g);
    }
    u((t = t.apply(e, n || [])).next());
  });
};
const io = (e) => {
  let {
    copyConfig: n,
    children: o
  } = e;
  const [t, r] = a.useState(!1), [l, s] = a.useState(!1), c = a.useRef(null), g = () => {
    c.current && clearTimeout(c.current);
  }, u = {};
  n.format && (u.format = n.format), a.useEffect(() => g, []);
  const i = Jt((v) => ao(void 0, void 0, void 0, function* () {
    var m;
    v == null || v.preventDefault(), v == null || v.stopPropagation(), s(!0);
    try {
      const E = typeof n.text == "function" ? yield n.text() : n.text;
      ro(E || String(o) || "", u), s(!1), r(!0), g(), c.current = setTimeout(() => {
        r(!1);
      }, 3e3), (m = n.onCopy) === null || m === void 0 || m.call(n, v);
    } catch (E) {
      throw s(!1), E;
    }
  }));
  return {
    copied: t,
    copyLoading: l,
    onClick: i
  };
};
function Xe(e, n) {
  return a.useMemo(() => {
    const o = !!e;
    return [o, Object.assign(Object.assign({}, n), o && typeof e == "object" ? e : null)];
  }, [e]);
}
const lo = (e) => {
  const n = ge();
  return $e(() => {
    n.current = e;
  }), n.current;
}, so = (e, n) => {
  const o = a.useRef(!1);
  a.useEffect(() => {
    o.current ? e() : o.current = !0;
  }, n);
};
var co = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
const lt = /* @__PURE__ */ a.forwardRef((e, n) => {
  const {
    prefixCls: o,
    component: t = "article",
    className: r,
    rootClassName: l,
    setContentRef: s,
    children: c,
    direction: g,
    style: u
  } = e, i = co(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: v,
    direction: m,
    typography: E
  } = a.useContext(Me), S = g ?? m;
  let z = n;
  s && (z = ot(n, s)), process.env.NODE_ENV !== "production" && Ne("Typography").deprecated(!s, "setContentRef", "ref");
  const H = v("typography", o), [M, V, f] = Pt(H), D = k(H, E == null ? void 0 : E.className, {
    [`${H}-rtl`]: S === "rtl"
  }, r, l, V, f), y = Object.assign(Object.assign({}, E == null ? void 0 : E.style), u);
  return M(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ a.createElement(t, Object.assign({
      className: D,
      style: y,
      ref: z
    }, i), c)
  );
});
process.env.NODE_ENV !== "production" && (lt.displayName = "Typography");
var uo = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
const fo = uo;
var po = function(n, o) {
  return /* @__PURE__ */ a.createElement(rt, we({}, n, {
    ref: o,
    icon: fo
  }));
}, Lt = /* @__PURE__ */ a.forwardRef(po);
process.env.NODE_ENV !== "production" && (Lt.displayName = "CopyOutlined");
const vo = Lt;
function vt(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
function _e(e, n, o) {
  return e === !0 || e === void 0 ? n : e || o && n;
}
const mo = (e) => {
  const {
    prefixCls: n,
    copied: o,
    locale: t,
    iconOnly: r,
    tooltips: l,
    icon: s,
    loading: c,
    tabIndex: g,
    onCopy: u
  } = e, i = vt(l), v = vt(s), {
    copied: m,
    copy: E
  } = t ?? {}, S = o ? _e(i[1], m) : _e(i[0], E), H = typeof S == "string" ? S : o ? m : E;
  return /* @__PURE__ */ a.createElement(it, {
    key: "copy",
    title: S
  }, /* @__PURE__ */ a.createElement(Qe, {
    className: k(`${n}-copy`, {
      [`${n}-copy-success`]: o,
      [`${n}-copy-icon-only`]: r
    }),
    onClick: u,
    "aria-label": H,
    tabIndex: g
  }, o ? _e(v[1], /* @__PURE__ */ a.createElement(nn, null), !0) : _e(v[0], c ? /* @__PURE__ */ a.createElement(an, null) : /* @__PURE__ */ a.createElement(vo, null), !0)));
}, go = mo, ze = /* @__PURE__ */ a.forwardRef((e, n) => {
  let {
    style: o,
    children: t
  } = e;
  const r = a.useRef(null);
  return a.useImperativeHandle(n, () => ({
    isExceed: () => {
      const l = r.current;
      return l.scrollHeight > l.clientHeight;
    },
    getHeight: () => r.current.clientHeight
  })), /* @__PURE__ */ a.createElement("span", {
    "aria-hidden": !0,
    ref: r,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      pointerEvents: "none",
      backgroundColor: "rgba(255, 0, 0, 0.65)"
    }, o)
  }, t);
});
function kt(e) {
  const n = typeof e;
  return n === "string" || n === "number";
}
function yo(e) {
  let n = 0;
  return e.forEach((o) => {
    kt(o) ? n += String(o).length : n += 1;
  }), n;
}
function mt(e, n) {
  let o = 0;
  const t = [];
  for (let r = 0; r < e.length; r += 1) {
    if (o === n)
      return t;
    const l = e[r], c = kt(l) ? String(l).length : 1, g = o + c;
    if (g > n) {
      const u = n - o;
      return t.push(String(l).slice(0, u)), t;
    }
    t.push(l), o = g;
  }
  return e;
}
const qe = 0, Ye = 1, Ge = 2, Ze = 3, gt = 4, je = {
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical"
};
function bo(e) {
  const {
    enableMeasure: n,
    width: o,
    text: t,
    children: r,
    rows: l,
    expanded: s,
    miscDeps: c,
    onEllipsis: g
  } = e, u = a.useMemo(() => Et(t), [t]), i = a.useMemo(() => yo(u), [t]), v = a.useMemo(() => r(u, !1), [t]), [m, E] = a.useState(null), S = a.useRef(null), z = a.useRef(null), H = a.useRef(null), M = a.useRef(null), V = a.useRef(null), [f, D] = a.useState(!1), [y, p] = a.useState(qe), [F, h] = a.useState(0), [d, G] = a.useState(null);
  Re(() => {
    p(n && o && i ? Ye : qe);
  }, [o, t, l, n, u]), Re(() => {
    var x, R, N, B;
    if (y === Ye) {
      p(Ge);
      const w = z.current && getComputedStyle(z.current).whiteSpace;
      G(w);
    } else if (y === Ge) {
      const w = !!(!((x = H.current) === null || x === void 0) && x.isExceed());
      p(w ? Ze : gt), E(w ? [0, i] : null), D(w);
      const W = ((R = H.current) === null || R === void 0 ? void 0 : R.getHeight()) || 0, P = l === 1 ? 0 : ((N = M.current) === null || N === void 0 ? void 0 : N.getHeight()) || 0, U = ((B = V.current) === null || B === void 0 ? void 0 : B.getHeight()) || 0, te = P + U, Z = Math.max(W, te);
      h(Z + 1), g(w);
    }
  }, [y]);
  const q = m ? Math.ceil((m[0] + m[1]) / 2) : 0;
  Re(() => {
    var x;
    const [R, N] = m || [0, 0];
    if (R !== N) {
      const w = (((x = S.current) === null || x === void 0 ? void 0 : x.getHeight()) || 0) > F;
      let W = q;
      N - R === 1 && (W = w ? R : N), E(w ? [R, W] : [W, N]);
    }
  }, [m, q]);
  const C = a.useMemo(() => {
    if (y !== Ze || !m || m[0] !== m[1]) {
      const x = r(u, !1);
      return y !== gt && y !== qe ? /* @__PURE__ */ a.createElement("span", {
        style: Object.assign(Object.assign({}, je), {
          WebkitLineClamp: l
        })
      }, x) : x;
    }
    return r(s ? u : mt(u, m[0]), f);
  }, [s, y, m, u].concat(nt(c))), j = {
    width: o,
    margin: 0,
    padding: 0,
    whiteSpace: d === "nowrap" ? "normal" : "inherit"
  };
  return /* @__PURE__ */ a.createElement(a.Fragment, null, C, y === Ge && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(ze, {
    style: Object.assign(Object.assign(Object.assign({}, j), je), {
      WebkitLineClamp: l
    }),
    ref: H
  }, v), /* @__PURE__ */ a.createElement(ze, {
    style: Object.assign(Object.assign(Object.assign({}, j), je), {
      WebkitLineClamp: l - 1
    }),
    ref: M
  }, v), /* @__PURE__ */ a.createElement(ze, {
    style: Object.assign(Object.assign(Object.assign({}, j), je), {
      WebkitLineClamp: 1
    }),
    ref: V
  }, r([], !0))), y === Ze && m && m[0] !== m[1] && /* @__PURE__ */ a.createElement(ze, {
    style: Object.assign(Object.assign({}, j), {
      top: 400
    }),
    ref: S
  }, r(mt(u, q), !0)), y === Ye && /* @__PURE__ */ a.createElement("span", {
    style: {
      whiteSpace: "inherit"
    },
    ref: z
  }));
}
const Mt = (e) => {
  let {
    enableEllipsis: n,
    isEllipsis: o,
    children: t,
    tooltipProps: r
  } = e;
  return !(r != null && r.title) || !n ? t : /* @__PURE__ */ a.createElement(it, Object.assign({
    open: o ? void 0 : !1
  }, r), t);
};
process.env.NODE_ENV !== "production" && (Mt.displayName = "EllipsisTooltip");
const ho = Mt;
var xo = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
function Eo(e, n) {
  let {
    mark: o,
    code: t,
    underline: r,
    delete: l,
    strong: s,
    keyboard: c,
    italic: g
  } = e, u = n;
  function i(v, m) {
    m && (u = /* @__PURE__ */ a.createElement(v, {}, u));
  }
  return i("strong", s), i("u", r), i("del", l), i("code", t), i("mark", o), i("kbd", c), i("i", g), u;
}
const So = "...", Co = /* @__PURE__ */ a.forwardRef((e, n) => {
  var o, t, r;
  const {
    prefixCls: l,
    className: s,
    style: c,
    type: g,
    disabled: u,
    children: i,
    ellipsis: v,
    editable: m,
    copyable: E,
    component: S,
    title: z
  } = e, H = xo(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: M,
    direction: V
  } = a.useContext(Me), [f] = Qt("Text"), D = a.useRef(null), y = a.useRef(null), p = M("typography", l), F = at(H, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [h, d] = Xe(m), [G, q] = Te(!1, {
    value: d.editing
  }), {
    triggerType: C = ["icon"]
  } = d, j = (b) => {
    var T;
    b && ((T = d.onStart) === null || T === void 0 || T.call(d)), q(b);
  }, x = lo(G);
  so(() => {
    var b;
    !G && x && ((b = y.current) === null || b === void 0 || b.focus());
  }, [G]);
  const R = (b) => {
    b == null || b.preventDefault(), j(!0);
  }, N = (b) => {
    var T;
    (T = d.onChange) === null || T === void 0 || T.call(d, b), j(!1);
  }, B = () => {
    var b;
    (b = d.onCancel) === null || b === void 0 || b.call(d), j(!1);
  }, [w, W] = Xe(E), {
    copied: P,
    copyLoading: U,
    onClick: te
  } = io({
    copyConfig: W,
    children: i
  }), [Z, Y] = a.useState(!1), [X, $] = a.useState(!1), [ae, ce] = a.useState(!1), [se, ue] = a.useState(!1), [ye, ne] = a.useState(!0), [Q, O] = Xe(v, {
    expandable: !1,
    symbol: (b) => b ? f == null ? void 0 : f.collapse : f == null ? void 0 : f.expand
  }), [K, Ee] = Te(O.defaultExpanded || !1, {
    value: O.expanded
  }), re = Q && (!K || O.expandable === "collapsible"), {
    rows: Se = 1
  } = O, Ce = a.useMemo(() => (
    // Disable ellipsis
    re && // Provide suffix
    (O.suffix !== void 0 || O.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    O.expandable || h || w)
  ), [re, O, h, w]);
  Re(() => {
    Q && !Ce && (Y(dt("webkitLineClamp")), $(dt("textOverflow")));
  }, [Ce, Q]);
  const [_, A] = a.useState(re), J = a.useMemo(() => Ce ? !1 : Se === 1 ? X : Z, [Ce, X, Z]);
  Re(() => {
    A(J && re);
  }, [J, re]);
  const be = re && (_ ? se : ae), he = re && Se === 1 && _, ie = re && Se > 1 && _, ve = (b, T) => {
    var xe;
    Ee(T.expanded), (xe = O.onExpand) === null || xe === void 0 || xe.call(O, b, T);
  }, [Ie, Fe] = a.useState(0), ee = (b) => {
    let {
      offsetWidth: T
    } = b;
    Fe(T);
  }, L = (b) => {
    var T;
    ce(b), ae !== b && ((T = O.onEllipsis) === null || T === void 0 || T.call(O, b));
  };
  a.useEffect(() => {
    const b = D.current;
    if (Q && _ && b) {
      const T = ie ? b.offsetHeight < b.scrollHeight : b.offsetWidth < b.scrollWidth;
      se !== T && ue(T);
    }
  }, [Q, _, i, ie, ye, Ie]), a.useEffect(() => {
    const b = D.current;
    if (typeof IntersectionObserver > "u" || !b || !_ || !re)
      return;
    const T = new IntersectionObserver(() => {
      ne(!!b.offsetParent);
    });
    return T.observe(b), () => {
      T.disconnect();
    };
  }, [_, re]);
  let oe = {};
  O.tooltip === !0 ? oe = {
    title: (o = d.text) !== null && o !== void 0 ? o : i
  } : /* @__PURE__ */ a.isValidElement(O.tooltip) ? oe = {
    title: O.tooltip
  } : typeof O.tooltip == "object" ? oe = Object.assign({
    title: (t = d.text) !== null && t !== void 0 ? t : i
  }, O.tooltip) : oe = {
    title: O.tooltip
  };
  const de = a.useMemo(() => {
    const b = (T) => ["string", "number"].includes(typeof T);
    if (!(!Q || _)) {
      if (b(d.text))
        return d.text;
      if (b(i))
        return i;
      if (b(z))
        return z;
      if (b(oe.title))
        return oe.title;
    }
  }, [Q, _, z, oe.title, be]);
  if (G)
    return /* @__PURE__ */ a.createElement(Zn, {
      value: (r = d.text) !== null && r !== void 0 ? r : typeof i == "string" ? i : "",
      onSave: N,
      onCancel: B,
      onEnd: d.onEnd,
      prefixCls: p,
      className: s,
      style: c,
      direction: V,
      component: S,
      maxLength: d.maxLength,
      autoSize: d.autoSize,
      enterIcon: d.enterIcon
    });
  const Vt = () => {
    const {
      expandable: b,
      symbol: T
    } = O;
    return !b || K && b !== "collapsible" ? null : /* @__PURE__ */ a.createElement(Qe, {
      key: "expand",
      className: `${p}-${K ? "collapse" : "expand"}`,
      onClick: (xe) => ve(xe, {
        expanded: !K
      }),
      "aria-label": K ? f.collapse : f == null ? void 0 : f.expand
    }, typeof T == "function" ? T(K) : T);
  }, Ft = () => {
    if (!h)
      return;
    const {
      icon: b,
      tooltip: T,
      tabIndex: xe
    } = d, Be = Et(T)[0] || (f == null ? void 0 : f.edit), Kt = typeof Be == "string" ? Be : "";
    return C.includes("icon") ? /* @__PURE__ */ a.createElement(it, {
      key: "edit",
      title: T === !1 ? "" : Be
    }, /* @__PURE__ */ a.createElement(Qe, {
      ref: y,
      className: `${p}-edit`,
      onClick: R,
      "aria-label": Kt,
      tabIndex: xe
    }, b || /* @__PURE__ */ a.createElement(Pn, {
      role: "button"
    }))) : null;
  }, Bt = () => w ? /* @__PURE__ */ a.createElement(go, Object.assign({
    key: "copy"
  }, W, {
    prefixCls: p,
    copied: P,
    locale: f,
    onCopy: te,
    loading: U,
    iconOnly: i == null
  })) : null, Ht = (b) => [
    // (renderExpanded || ellipsisConfig.collapsible) && renderExpand(),
    b && Vt(),
    Ft(),
    Bt()
  ], Wt = (b) => [b && !K && /* @__PURE__ */ a.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, So), O.suffix, Ht(b)];
  return /* @__PURE__ */ a.createElement(xt, {
    onResize: ee,
    disabled: !re
  }, (b) => /* @__PURE__ */ a.createElement(ho, {
    tooltipProps: oe,
    enableEllipsis: re,
    isEllipsis: be
  }, /* @__PURE__ */ a.createElement(lt, Object.assign({
    className: k({
      [`${p}-${g}`]: g,
      [`${p}-disabled`]: u,
      [`${p}-ellipsis`]: Q,
      [`${p}-ellipsis-single-line`]: he,
      [`${p}-ellipsis-multiple-line`]: ie
    }, s),
    prefixCls: l,
    style: Object.assign(Object.assign({}, c), {
      WebkitLineClamp: ie ? Se : void 0
    }),
    component: S,
    ref: ot(b, D, n),
    direction: V,
    onClick: C.includes("text") ? R : void 0,
    "aria-label": de == null ? void 0 : de.toString(),
    title: z
  }, F), /* @__PURE__ */ a.createElement(bo, {
    enableMeasure: re && !_,
    text: i,
    rows: Se,
    width: Ie,
    onEllipsis: L,
    expanded: K,
    miscDeps: [P, K, U, h, w]
  }, (T, xe) => Eo(e, /* @__PURE__ */ a.createElement(a.Fragment, null, T.length > 0 && xe && !K && de ? /* @__PURE__ */ a.createElement("span", {
    key: "show-content",
    "aria-hidden": !0
  }, T) : T, Wt(xe)))))));
}), Ve = Co;
var wo = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
const Oo = /* @__PURE__ */ a.forwardRef((e, n) => {
  var {
    ellipsis: o,
    rel: t
  } = e, r = wo(e, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const s = Ne("Typography.Link");
    process.env.NODE_ENV !== "production" && s(typeof o != "object", "usage", "`ellipsis` only supports boolean value.");
  }
  const l = Object.assign(Object.assign({}, r), {
    rel: t === void 0 && r.target === "_blank" ? "noopener noreferrer" : t
  });
  return delete l.navigate, /* @__PURE__ */ a.createElement(Ve, Object.assign({}, l, {
    ref: n,
    ellipsis: !!o,
    component: "a"
  }));
}), Ro = Oo, No = /* @__PURE__ */ a.forwardRef((e, n) => /* @__PURE__ */ a.createElement(Ve, Object.assign({
  ref: n
}, e, {
  component: "div"
}))), $o = No;
var To = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
const Io = (e, n) => {
  var {
    ellipsis: o
  } = e, t = To(e, ["ellipsis"]);
  const r = a.useMemo(() => o && typeof o == "object" ? at(o, ["expandable", "rows"]) : o, [o]);
  if (process.env.NODE_ENV !== "production") {
    const l = Ne("Typography.Text");
    process.env.NODE_ENV !== "production" && l(typeof o != "object" || !o || !("expandable" in o) && !("rows" in o), "usage", "`ellipsis` do not support `expandable` or `rows` props.");
  }
  return /* @__PURE__ */ a.createElement(Ve, Object.assign({
    ref: n
  }, t, {
    ellipsis: r,
    component: "span"
  }));
}, _o = /* @__PURE__ */ a.forwardRef(Io);
var zo = function(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
      n.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (o[t[r]] = e[t[r]]);
  return o;
};
const yt = [1, 2, 3, 4, 5], jo = /* @__PURE__ */ a.forwardRef((e, n) => {
  const {
    level: o = 1
  } = e, t = zo(e, ["level"]);
  let r;
  if (process.env.NODE_ENV !== "production") {
    const l = Ne("Typography.Title");
    process.env.NODE_ENV !== "production" && l(yt.includes(o), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.");
  }
  return yt.includes(o) ? r = `h${o}` : r = "h1", /* @__PURE__ */ a.createElement(Ve, Object.assign({
    ref: n
  }, t, {
    component: r
  }));
}), Ao = jo, Oe = lt;
Oe.Text = _o;
Oe.Link = Ro;
Oe.Title = Ao;
Oe.Paragraph = $o;
const tr = Pe(Oe.Text)`
  ${({
  fs: e
}) => e && Le`
      font-size: var(--fs-${e});
    `}
`, nr = Pe(Oe.Link)`
  ${({
  fs: e
}) => e && Le`
      font-size: var(--fs-${e});
    `}
`, or = Pe(Oe.Paragraph)`
  ${({
  fs: e
}) => e && Le`
      font-size: var(--fs-${e});
    `}
`, rr = Pe(Oe.Title)`
  ${({
  fs: e
}) => e && Le`
      font-size: var(--fs-${e});
    `}
`;
export {
  er as I,
  tr as S,
  Oe as T,
  nr as a,
  rr as b,
  or as c,
  Tn as d,
  mn as u
};
//# sourceMappingURL=style-B5VBq8yY.mjs.map
